import React, { type ComponentType } from 'react';
import Heading from '@atlaskit/heading';
import PageHeader from '@atlassian/jira-common-components-page-header';
import {
	type IssueContainerName,
	PROJECT_ISSUE_CONTAINER_NAME,
} from '@atlassian/jira-common-constants/src/issue-container-names';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import messages from './messages';

export type Props = {
	issueContainerName: IssueContainerName;
	Menu: ComponentType<{
		issueContainerName: IssueContainerName;
	}>;
	isSimplified?: boolean;
	isAdmin?: boolean;
};

type PropsWithIntl = Props & {
	intl: IntlShape;
};

export function Header(props: PropsWithIntl) {
	const { Menu, intl, issueContainerName, isSimplified, isAdmin } = props;
	return (
		<PageHeader
			truncateTitle
			disableTitleStyles
			actions={
				!isSimplified && !isAdmin ? undefined : <Menu issueContainerName={issueContainerName} />
			}
		>
			<Heading size="large" as="h1">
				{intl.formatMessage(messages.title)}
			</Heading>
		</PageHeader>
	);
}

export const defaultProps = {
	issueContainerName: PROJECT_ISSUE_CONTAINER_NAME,
} as const;

export default injectIntl(Header);
